// Contract Filter Options Constants
export const CONTRACT_FILTER_OPTIONS = {
  STATUS: [
    { value: '', label: 'All Statuses' },
    { value: 'open', label: 'Open' },
    { value: 'in_progress', label: 'In Progress' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'disputed', label: 'Disputed' },
  ],

  PAYMENT_TYPE: [
    { value: '', label: 'All Types' },
    { value: 'fixed', label: 'Fixed Price' },
    { value: 'hourly', label: 'Hourly Rate' },
  ],

  EXPERTISE_LEVEL: [
    { value: '', label: 'All Levels' },
    { value: 'beginner', label: 'Beginner' },
    { value: 'intermediate', label: 'Intermediate' },
    { value: 'expert', label: 'Expert' },
  ],
};

// Helper function to create category options from API data
export const createCategoryOptions = (categories) => [
  { value: '', label: 'All Categories' },
  ...categories.map((category) => ({
    value: category.slug || category.name || category,
    label: category.name || category,
  })),
];

// Tech Stack Options List
export const TECH_STACK_OPTIONS = [
  // Frontend Technologies
  { value: 'react', label: 'React' },
  { value: 'vue', label: 'Vue.js' },
  { value: 'angular', label: 'Angular' },
  { value: 'javascript', label: 'JavaScript' },
  { value: 'typescript', label: 'TypeScript' },
  { value: 'html', label: 'HTML' },
  { value: 'css', label: 'CSS' },
  { value: 'sass', label: 'Sass/SCSS' },
  { value: 'tailwind', label: 'Tailwind CSS' },
  { value: 'bootstrap', label: 'Bootstrap' },
  { value: 'jquery', label: 'jQuery' },
  { value: 'nextjs', label: 'Next.js' },
  { value: 'nuxtjs', label: 'Nuxt.js' },
  { value: 'svelte', label: 'Svelte' },

  // Backend Technologies
  { value: 'nodejs', label: 'Node.js' },
  { value: 'python', label: 'Python' },
  { value: 'django', label: 'Django' },
  { value: 'flask', label: 'Flask' },
  { value: 'fastapi', label: 'FastAPI' },
  { value: 'java', label: 'Java' },
  { value: 'spring', label: 'Spring Boot' },
  { value: 'csharp', label: 'C#' },
  { value: 'dotnet', label: '.NET' },
  { value: 'php', label: 'PHP' },
  { value: 'laravel', label: 'Laravel' },
  { value: 'symfony', label: 'Symfony' },
  { value: 'ruby', label: 'Ruby' },
  { value: 'rails', label: 'Ruby on Rails' },
  { value: 'go', label: 'Go' },
  { value: 'rust', label: 'Rust' },
  { value: 'express', label: 'Express.js' },

  // Databases
  { value: 'mysql', label: 'MySQL' },
  { value: 'postgresql', label: 'PostgreSQL' },
  { value: 'mongodb', label: 'MongoDB' },
  { value: 'redis', label: 'Redis' },
  { value: 'sqlite', label: 'SQLite' },
  { value: 'elasticsearch', label: 'Elasticsearch' },
  { value: 'cassandra', label: 'Cassandra' },
  { value: 'dynamodb', label: 'DynamoDB' },

  // Cloud & DevOps
  { value: 'aws', label: 'AWS' },
  { value: 'azure', label: 'Microsoft Azure' },
  { value: 'gcp', label: 'Google Cloud Platform' },
  { value: 'docker', label: 'Docker' },
  { value: 'kubernetes', label: 'Kubernetes' },
  { value: 'jenkins', label: 'Jenkins' },
  { value: 'gitlab-ci', label: 'GitLab CI' },
  { value: 'github-actions', label: 'GitHub Actions' },
  { value: 'terraform', label: 'Terraform' },
  { value: 'ansible', label: 'Ansible' },

  // Mobile Development
  { value: 'react-native', label: 'React Native' },
  { value: 'flutter', label: 'Flutter' },
  { value: 'swift', label: 'Swift' },
  { value: 'kotlin', label: 'Kotlin' },
  { value: 'ionic', label: 'Ionic' },
  { value: 'xamarin', label: 'Xamarin' },

  // Data Science & AI
  { value: 'tensorflow', label: 'TensorFlow' },
  { value: 'pytorch', label: 'PyTorch' },
  { value: 'scikit-learn', label: 'Scikit-learn' },
  { value: 'pandas', label: 'Pandas' },
  { value: 'numpy', label: 'NumPy' },
  { value: 'jupyter', label: 'Jupyter' },
  { value: 'r', label: 'R' },
  { value: 'matlab', label: 'MATLAB' },

  // Testing
  { value: 'jest', label: 'Jest' },
  { value: 'cypress', label: 'Cypress' },
  { value: 'selenium', label: 'Selenium' },
  { value: 'pytest', label: 'PyTest' },
  { value: 'junit', label: 'JUnit' },
  { value: 'mocha', label: 'Mocha' },

  // Tools & Others
  { value: 'git', label: 'Git' },
  { value: 'webpack', label: 'Webpack' },
  { value: 'vite', label: 'Vite' },
  { value: 'babel', label: 'Babel' },
  { value: 'eslint', label: 'ESLint' },
  { value: 'prettier', label: 'Prettier' },
  { value: 'figma', label: 'Figma' },
  { value: 'adobe-xd', label: 'Adobe XD' },
  { value: 'sketch', label: 'Sketch' },
];

// Helper function to create tech stack options from API data
export const createTechStackOptions = (skills) =>
  skills.map((skill) => ({
    value: skill.slug || skill.name || skill,
    label: skill.name || skill,
  }));

// Page configuration
export const PAGE_CONFIG = {
  PAGE_SIZE: 20,
  PAGE_NO: 1,
};

export const CONTRACT_STATUS = {
  ALL: 'all',
  ACTIVE: 'open',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

export const CONTRACT_FILTER_KEYS = {
  STATUS: 'status',
  PAYMENT_TYPE: 'paymentType',
  CATEGORY: 'category',
  EXPERTISE: 'expertise',
  MIN_AMOUNT: 'minAmount',
  MAX_AMOUNT: 'maxAmount',
  SEARCH: 'search',
  TECH_STACK: 'techStack',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
};

const {
  STATUS,
  PAYMENT_TYPE,
  EXPERTISE,
  MIN_AMOUNT,
  MAX_AMOUNT,
  SEARCH,
  TECH_STACK,
  START_DATE,
  END_DATE,
  CATEGORY,
} = CONTRACT_FILTER_KEYS;

// Default filter values
export const DEFAULT_FILTERS = {
  [STATUS]: '',
  [PAYMENT_TYPE]: '',
  [CATEGORY]: '',
  [EXPERTISE]: '',
  [MIN_AMOUNT]: '',
  [MAX_AMOUNT]: '',
  [SEARCH]: '',
  [TECH_STACK]: [],
  [START_DATE]: '',
  [END_DATE]: '',
};

// Maximum number of profiles that can be selected
export const MAX_SELECT_PROFILE = 5;

// Pagination constants
export const INITIAL_PAGE_SIZE = 6;
export const INITIAL_PAGE = 1;

// Match state constants
export const MATCH_STATE = {
  NEUTRAL: 'neutral',
  SELECTED: 'selected',
  DECLINED: 'declined',
};
